import { IInventoryPage } from '../../../inventory-page.interface';


export const UPLOAD_POD_TM_WHITELIST_PAGE: IInventoryPage = {
	'route': '/upload/pod/tm-whitelist',
	'title': 'TM Whitelist',
	'uiReference': [
		'Whitelist tools',
		'Enter a term to ignore',
		'Add an optional note',
		'Whitelist entry',
		'Ignore a trademark term',
		'Add words that should be excluded from your trademark checks.',
		'Language words',
		'Import',
		'Export',
		'Word or phrase',
		'Language',
		'Note',
		'Add to whitelist',
		'The spreadsheet import supports the following formats: .csv, .xls, .xlsx, .odt. The format of the excel sheet has to be as the example shown below. Please pay special attention to the column naming. The columns can be rearranged and will be detected in any order.',
		'Filter saved terms',
		'Filter personal notes',
		'Loading saved terms...',
		'Saved terms',
		'entries',
		'Delete all',
		'Filter results',
		'Refine entries',
		'Filter options',
		'Reset filters',
		'No records found',
		'Adjust the filters to see more saved terms.'
	],
	'sources': [
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/pod-routing.module.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/trademarks/tm-whitelist/tm-whitelist.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/trademarks/tm-whitelist/tm-whitelist.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/trademarks/shared/tm-list/tm-list.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/trademarks/shared/tm-list/tm-list.data.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/trademarks/shared/tm-list/tm-list.component.html',
		'apps/flying-projects/frontend/webapp/src/app/components/inform-cards/info-card/info-card.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/components/inform-cards/info-card/info-card.component.html'
	],
	'aliases': []
};
